export const correctionDrawingsPaginationCount = 15;
export const orderPaginationCount = 15;
export const companyContactsPaginationCount = 15;
export const productsPaginationCount = 15;
